module.exports = __webpack_public_path__ + "img/logo_dwhtest_wheel.c33230d7.png";